import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { MENU, PHONE_TEL } from "../../data/menu";

const card = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.12 },
  }),
};

export const Menu = () => {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-24 md:py-40">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 md:mb-24">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-display uppercase leading-none tracking-tight text-6xl md:text-9xl"
          >
            The <span className="text-[#e63946]">Menu</span>
          </motion.h2>
          <p className="font-body uppercase tracking-[0.3em] text-xs md:text-sm text-[#a8a8a8] max-w-xs">
            Call to order — we cook it fresh & bring it to you
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-white/10">
          {MENU.map((item, i) => (
            <motion.article
              key={item.id}
              custom={i}
              variants={card}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`menu-item-${item.id}`}
              className={`group relative border-b border-r border-white/10 p-6 md:p-10 ${item.featured ? "md:col-span-2" : ""}`}
            >
              <div className={`relative overflow-hidden ${item.featured ? "rounded-md aspect-[16/9] bg-black" : "rounded-t-[120px] rounded-b-md aspect-[4/3]"} mb-6 border border-white/10`}>
                <img
                  src={item.img}
                  alt={item.name}
                  className={`h-full w-full ${item.featured ? "object-contain" : "object-cover"} transition-transform duration-[900ms] ease-out group-hover:scale-105`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <span className="absolute top-3 left-1/2 -translate-x-1/2 font-body uppercase tracking-widest text-[10px] md:text-xs bg-black/70 backdrop-blur px-4 py-1.5 rounded-full text-[#ffb703] border border-white/10 whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute bottom-3 right-4 flex items-baseline font-accent leading-none text-[#ffb703] drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]">
                  <span className="text-2xl md:text-3xl">$</span>
                  <span className="text-5xl md:text-7xl">{item.price}</span>
                  <span className="text-xl md:text-2xl">.{item.cents}</span>
                </div>
              </div>

              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display uppercase text-3xl md:text-4xl leading-none tracking-tight text-white group-hover:text-[#e63946] transition-colors duration-300">
                    {item.name}
                  </h3>
                  <p className="mt-3 font-body text-sm md:text-base text-[#a8a8a8] leading-relaxed max-w-md">
                    {item.desc}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row justify-center items-center gap-4">
          <a
            href="#order"
            data-testid="menu-order-button"
            className="group inline-flex items-center gap-3 rounded-full bg-[#e63946] px-8 py-4 font-accent uppercase tracking-wide text-white text-lg transition-all duration-300 hover:bg-[#ffb703] hover:text-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#ffb703]"
          >
            Request An Order
          </a>
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="menu-call-button"
            className="group inline-flex items-center gap-3 rounded-full border border-[#e63946] bg-transparent px-8 py-4 font-accent uppercase tracking-wide text-white text-lg transition-all duration-300 hover:bg-[#e63946] hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#ffb703]"
          >
            <Phone className="h-5 w-5 transition-transform group-hover:rotate-12" />
            Call To Order
          </a>
        </div>
      </div>
    </section>
  );
};
